import { useEffect, useState } from 'react';
import { compareWithAppVersion } from '@croquiscom/web2app';

export const useCompareAppVersion = (version: string) => {
  const [isAvailable, setIsAvailable] = useState(false);

  useEffect(() => {
    setIsAvailable(compareWithAppVersion(version));
  }, [version]);

  return isAvailable;
};
